<template>
  <div class="customers__all">
    <div class="customers__all__header">
      <h1 class="font-bold text-xl">Titles and Subtitles</h1>
    </div>
    <div class="customers__all__container">
      <Table :columns="columns" :data="titles_subtitles">
        <template v-slot:id="scope">
          <Icon name="Document" class="advertisement__icon" />
          <p>{{ scope.item.id }}</p>
        </template>
        <template v-slot:section="scope">
          {{ scope.item.section }}
        </template>
        <template v-slot:title="scope">
          {{ scope.item.title }}
        </template>
        <template v-slot:subtitle="scope">
          {{ scope.item.subtitle }}
        </template>
        <template v-slot:actions="scope">
          <router-link :to="`/titles-subtitles/edit/${scope.item.id}`">
            <a-button>Edit</a-button>
          </router-link>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import Table from "@/components/Table/index";

export default {
  components: { Table },
  setup() {
    const store = useStore();
    onMounted(() => {
      store.dispatch("GET_TITLES_SUBTITLES");
    });
    const columns = ref([
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        style: {
          width: "350px",
          flex: "none",
        },
        slot: true,
      },
      {
        title: "Section",
        dataIndex: "section",
        key: "section",
        slot: true,
      },
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
        slot: true,
      },
      {
        title: "Subtitle",
        dataIndex: "subtitle",
        key: "subtitle",
        style: {
          width: "450px",
          flex: "none",
        },
        slot: true,
      },
      {
        title: "Actions",
        dataIndex: "actions",
        key: "actions",
        slot: true,
        style: {
          width: "350px",
        },
      },
    ]);

    const titles_subtitles = computed(() => store.state.title_subtitle);

    return {
      columns,
      titles_subtitles,
    };
  },
};
</script>

<style scoped>
.customers__all {
  max-width: calc(100vw - 200px);
  margin: 0 auto;
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
}
.customers__all__header {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.customers__all__container {
  max-width: calc(100vw - 200px);
  height: calc(100vh - 80px);
}
.soon {
  @apply bg-yellow-500 text-white px-2;
}
.expired {
  @apply bg-red-500 text-white px-2;
}
</style>
